<template>
  <div>
    <common-dialog
      ref="dialog"
      width="400px"
      line-form
      show-save-button
      unit="账号类型"
      edit-title
      id-key="AccountTypeId"
      :data="data"
      @create-opened="onCreateOpened"
      :form-rules="rules"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="账号类型" prop="AccountType">
          <el-input v-model="data.AccountType" placeholder="请输入账号类型" />
        </el-form-item>
        <el-form-item label prop="HaveBank">
          <el-checkbox v-model="data.HaveBank">是否有开户行</el-checkbox>
        </el-form-item>
        <el-form-item label="序号" prop="SerialNumber">
          <el-input v-model="data.SerialNumber" v-int style="width: 100px;" />
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        <!-- <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="data.Status" class="detail-span">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>-->
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        AccountTypeId: 0,
        AccountType: "",
        HaveBank: true, //是否有开户行
        SerialNumber: 0,
      },
      api: require("@/api/ba/accountType").default,
      rules: {
        AccountType: [{ required: true, message: "账号类型不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.api.getMaxSn().then((res) => {
        this.data.SerialNumber = res;
      });
    },
  },
};
</script>